export class StripePaymentInfo 
{
    constructor(amount:number, currency:'EUR' | 'BRL', source:string, description:string, stripecustomerid:string)
    {
        this.Amount = amount;
        this.Currency = currency;
        this.Source = source;
        this.Description = description;
        this.StripeCustomerID = stripecustomerid;
    }

    public Amount;
    public Currency;
    public Source;
    public Description;
    public StripeCustomerID;
}
